import { RealTimeRecordingWithSegments } from '@ftr/api-regional'
import { AudioSegmentPlaybackData } from '@ftr/contracts/api/audio-segment'
import { Uuid } from '@ftr/contracts/type/shared'

export interface RealTimePlaybackAudioSegmentKey {
  audioSegmentId: Uuid
  recordingId: Uuid
}

export interface RealTimePlaybackRecordingKey {
  recordingId: Uuid
}

export interface RealTimePlaybackHearingKey {
  hearingId: Uuid
  recordingId: Uuid
}

export type RealTimePlaybackKey =
  | RealTimePlaybackAudioSegmentKey
  | RealTimePlaybackRecordingKey
  | RealTimePlaybackHearingKey

export function getRecordingPlaybackKey(recording: RealTimeRecordingWithSegments): RealTimePlaybackRecordingKey {
  return { recordingId: recording.id }
}

export function getAudioSegmentPlaybackKey(audioSegment: AudioSegmentPlaybackData): RealTimePlaybackAudioSegmentKey {
  return {
    audioSegmentId: audioSegment.id,
    recordingId: audioSegment.recordingId!,
  }
}
